import { jsx as e, jsxs as c } from "react/jsx-runtime";
import d from "../../utils/classNames.js";
import v from "../fade/Fade.js";
const S = (i) => {
  const { isInverse: r, isDoubleSized: s, ...n } = i, l = d("spinner", r && "inverse", s && "double");
  return /* @__PURE__ */ c("div", { ...n, className: l, children: [
    /* @__PURE__ */ e("div", {}),
    /* @__PURE__ */ e("div", {}),
    /* @__PURE__ */ e("div", {}),
    /* @__PURE__ */ e("div", {})
  ] });
}, g = (i) => {
  const {
    isInverse: r = !1,
    isFullSized: s = !1,
    isFullScreen: n = !1,
    isDoubleSized: l = !1,
    isInline: f = !1,
    show: p = !1,
    text: t,
    ...u
  } = i, a = /* @__PURE__ */ e(S, { isDoubleSized: l, isInverse: r, ...u });
  if (f)
    return a;
  const m = d(
    "spinnerInfoBox display-flex justify-content-center align-items-center height-100pct",
    s && "fullsized",
    n && "fullscreen"
  ), o = /* @__PURE__ */ c("div", { className: m, children: [
    a,
    t && /* @__PURE__ */ e("div", { className: "spinnerText", children: t })
  ] });
  return n || s ? /* @__PURE__ */ e(v, { show: p, duration: 0.1, children: o }) : o;
};
export {
  g as default
};
//# sourceMappingURL=Spinner.js.map
